import Splide, { Options } from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';

const sliderSections = document.querySelectorAll(".s-agents-slider")

sliderSections.forEach(slideSection => {
  const slider = slideSection.querySelector<HTMLElement>(".s-agents-slider__splide")

  if (slider === null) return

  const splideOptions: Options = {
    pagination: false,
    keyboard: true,
    grid: {
      rows: 2,
      cols: 1,
      gap: {
        row: '1rem',
        col: '1rem',
      },
    },
    breakpoints: {
      768: {
        perPage: 1,
        fixedWidth: "100%",
        width: "100%",
        grid: false
      }
    }
  }

  new Splide(slider, splideOptions).mount({ Grid });

})


